import { Component, OnInit, Input } from '@angular/core';
import { WalkmeModel } from '@omnitracs/walkme-component';
import { AuthService } from '../../auth';
import { PlatformLocation } from '@angular/common';
import { UserService } from '../../user';

@Component({
  selector: 'ot-walkme-container',
  templateUrl: './walkme-container.component.html',
  styleUrls: ['./walkme-container.component.scss']
})
export class WalkmeContainerComponent implements OnInit {
  @Input() appName;

  walkmeConfig: WalkmeModel;

  constructor(
    public authService: AuthService,
    private platformLocation: PlatformLocation,
    public userService: UserService
  ) {}

  ngOnInit() {
    this.walkmeConfig = {
      isProdEnv: this.verifyIfEnvironmentIsProd(),
      applicationName: this.appName,
      token: this.userService.getDecodedToken(this.authService.getAccessToken())
    };
  }

  verifyIfEnvironmentIsProd(): boolean {
    return this.getBaseHrefFromDOM().includes('omnitracsone.com');
  }

  getBaseHrefFromDOM(): string {
    return this.platformLocation.getBaseHrefFromDOM();
  }
}
